/* =========================================================
   Catedo 27.08.2026 — Fluidité perçue du tiroir panier.
   Le temps d'attente réel vient des réponses Shopify
   (/cart/add.js : 0,6 à 2 s) : on ne peut pas le réduire.
   Ce module fait réagir l'interface immédiatement (< 100 ms)
   sans inventer le moindre montant :
   - on instrumente window.fetch pour /cart/add et /cart/change
     (mêmes requêtes qu'avant, aucune requête ajoutée) ;
   - à l'envoi d'un ajout : ouverture immédiate du tiroir +
     carte squelette « Ajout en cours… » (prix en barre grise) ;
   - à la réponse : le rendu réel (renderContents / sections
     Shopify) remplace l'état provisoire ;
   - en échec : nettoyage complet, fermeture du tiroir si on
     l'avait ouvert par anticipation (pour rendre visible le
     message d'erreur de la fiche), message accessible.
   Expose window.CatedoCartFluid.busy : le carrousel du tiroir
   s'en sert pour différer ses reconstructions pendant qu'une
   requête panier est en vol.
   ========================================================= */
(function () {
  'use strict';
  if (window.CatedoCartFluid) return;

  var state = {
    busy: 0,               /* requêtes /cart/add|change|update en vol */
    openedByFluid: false,  /* le tiroir a été ouvert par anticipation */
    skipNextAddUI: false,  /* « Acheter maintenant » : pas de tiroir */
    lastProductForm: null, /* fiche source du dernier ajout (erreurs) */
    safetyTimer: null
  };
  window.CatedoCartFluid = state;

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  /* Capture des soumissions de formulaire produit :
     - mémorise la fiche source pour pouvoir afficher une erreur réseau ;
     - un formulaire « Acheter maintenant » (data-skip-cart) redirige vers
       /checkout : on ne doit pas ouvrir le tiroir dans ce cas. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    state.lastProductForm = form.closest('product-form');
    var idInput = form.querySelector('[name=id]');
    state.skipNextAddUI = !!(idInput && idInput.dataset && idInput.dataset.skipCart === 'true');
  }, true);

  /* Carte squelette : mêmes cotes qu'une carte article du tiroir.
     role="status" : « Ajout en cours… » est annoncé aux lecteurs d'écran. */
  function buildSkeleton() {
    var el = document.createElement('div');
    el.className = 'cart-fluid-skel';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<div class="cart-fluid-skel__media"></div>' +
      '<div class="cart-fluid-skel__body">' +
        '<span class="cart-fluid-skel__bar cart-fluid-skel__bar--title"></span>' +
        '<span class="cart-fluid-skel__bar cart-fluid-skel__bar--sub"></span>' +
        '<span class="cart-fluid-skel__note">Ajout en cours…</span>' +
      '</div>' +
      '<span class="cart-fluid-skel__bar cart-fluid-skel__bar--price"></span>';
    return el;
  }

  function beginAddUI() {
    var drawer = drawerEl();
    if (!drawer) return false;
    var container = document.getElementById('CartDrawer-CartItems');
    if (container && !container.querySelector('.cart-fluid-skel')) {
      container.insertBefore(buildSkeleton(), container.firstChild);
    }
    drawer.classList.add('is-adding', 'catedo-amounts-updating');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.setAttribute('aria-busy', 'true');
    if (!drawer.classList.contains('active') && typeof drawer.open === 'function') {
      state.openedByFluid = true;
      drawer.open();
    }
    return true;
  }

  function clearPendingUI() {
    var drawer = drawerEl();
    if (drawer) {
      drawer.classList.remove('is-adding', 'catedo-amounts-updating');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.removeAttribute('aria-busy');
    }
    var skels = document.querySelectorAll('.cart-fluid-skel');
    for (var i = 0; i < skels.length; i++) skels[i].remove();
    state.openedByFluid = false;
    if (state.safetyTimer) { clearTimeout(state.safetyTimer); state.safetyTimer = null; }
  }

  /* Filet de sécurité : quoi qu'il arrive, aucun état provisoire bloqué.
     Il ne vise QUE le cas où aucune réponse n'arrive jamais ; il est
     désarmé dès qu'une requête se termine normalement (settleAdd). */
  function armSafetyTimer() {
    if (state.safetyTimer) clearTimeout(state.safetyTimer);
    state.safetyTimer = setTimeout(clearPendingUI, 20000);
  }

  function disarmSafetyTimer() {
    if (state.safetyTimer) { clearTimeout(state.safetyTimer); state.safetyTimer = null; }
  }

  function onAddFailed(networkError) {
    var drawer = drawerEl();
    var opened = state.openedByFluid;
    clearPendingUI();
    /* L'erreur s'affiche sur la fiche produit : on referme le tiroir
       ouvert par anticipation pour qu'elle soit visible. close()
       restitue le focus au bouton d'origine (activeElement). */
    if (drawer && opened && typeof drawer.close === 'function') drawer.close();
    /* Erreur réseau : product-form ne l'affiche pas (catch silencieux),
       on utilise sa propre zone d'erreur accessible. */
    if (networkError && state.lastProductForm &&
        typeof state.lastProductForm.handleErrorMessage === 'function') {
      var msg = (window.cartStrings && window.cartStrings.error) ||
        (window.CatedoStrings && window.CatedoStrings.cartError) ||
        'Une erreur est survenue. Merci de réessayer.';
      state.lastProductForm.handleErrorMessage(msg);
    }
  }

  function settleAdd(uiShown, failed, networkError) {
    if (!uiShown) return;
    /* Règlement normal : le filet anti-blocage de 20 s n'a plus d'objet,
       sauf si un autre ajout est encore en vol (il garde alors son filet). */
    if (state.busy === 0) disarmSafetyTimer();
    if (failed) {
      onAddFailed(networkError);
    } else {
      /* Succès : renderContents retire l'état provisoire et injecte les
         sections réelles dans la même passe de rendu. Ce délai n'est
         qu'un filet de sécurité (parcours quick-add, etc.). */
      setTimeout(function () {
        if (state.busy === 0 && (document.querySelector('.cart-fluid-skel') ||
            (drawerEl() && drawerEl().classList.contains('is-adding')))) {
          clearPendingUI();
        }
      }, 400);
    }
  }

  /* Filtre strict : seuls les véritables endpoints panier Shopify du
     domaine courant sont observés (chemins issus de window.routes, repli
     sur les chemins standards). Toute autre requête — apps, pixels,
     analytics, hôtes tiers même avec un chemin ressemblant — passe
     intacte sans la moindre observation. */
  function classifyCartRequest(input) {
    try {
      var rawUrl = typeof input === 'string' ? input : ((input && input.url) || '');
      if (!rawUrl) return null;
      var parsed = new URL(rawUrl, window.location.origin);
      if (parsed.origin !== window.location.origin) return null;
      var r = window.routes || {};
      var addPath = r.cart_add_url || '/cart/add';
      var changePath = r.cart_change_url || '/cart/change';
      var updatePath = r.cart_update_url || '/cart/update';
      if (parsed.pathname.indexOf(addPath) === 0) return 'add';
      if (parsed.pathname.indexOf(changePath) === 0 || parsed.pathname.indexOf(updatePath) === 0) return 'change';
      return null;
    } catch (e) {
      return null;
    }
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var kind = classifyCartRequest(input);
    var isAdd = kind === 'add';
    var isChange = kind === 'change';
    if (!isAdd && !isChange) return origFetch.apply(window, arguments);

    state.busy++;
    var uiShown = false;
    if (isAdd) {
      if (state.skipNextAddUI) {
        state.skipNextAddUI = false;
      } else {
        try { uiShown = beginAddUI(); } catch (e) { uiShown = false; }
        if (uiShown) armSafetyTimer();
      }
    }

    var result = origFetch.apply(window, arguments);
    result.then(function (response) {
      state.busy = Math.max(0, state.busy - 1);
      if (isAdd) settleAdd(uiShown, !response.ok, false);
    }, function () {
      state.busy = Math.max(0, state.busy - 1);
      if (isAdd) settleAdd(uiShown, true, true);
    });
    return result;
  };
})();
